// src/data/news.js

export const newsData = [
  {
    id: 1,
    slug: "quyen-gop-giup-do-dong-bao-vung-lu-mien-trung-2026",
    title: "Thông báo về việc quyên góp giúp đỡ đồng bào vùng lũ miền Trung",
    category: "Bác ái",
    date: "14/05/2026",
    summary:
      "Hưởng ứng lời kêu gọi của Đức Cha Giáo phận, Giáo xứ tổ chức đợt quyên góp đặc biệt nhằm sẻ chia với anh chị em vùng lũ.",
    content:
      "Giáo xứ kêu gọi toàn thể cộng đoàn quảng đại đóng góp bằng tiền mặt hoặc nhu yếu phẩm để hỗ trợ đồng bào miền Trung vượt qua khó khăn.",
    image:
      "https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?q=80&w=1200",
    featured: true,
  },

  {
    id: 2,
    slug: "thu-ngo-gui-cac-gia-dinh-tre-ve-giao-duc-duc-tin",
    title: "Thư ngỏ gửi các gia đình trẻ về giáo dục đức tin",
    category: "Thư ngỏ",
    date: "13/05/2026",
    summary:
      "Lời nhắn gửi đến các bậc cha mẹ về vai trò giáo dục đức tin trong gia đình.",
    content:
      "Gia đình là Giáo Hội tại gia. Việc giáo dục đức tin cho con cái cần được quan tâm và đồng hành mỗi ngày.",
    image:
      "https://images.unsplash.com/photo-1511895426328-dc8714191300?q=80&w=600",
    featured: true,
  },

  {
    id: 3,
    slug: "lich-giai-toi-va-tinh-tam-mua-hoa-2026",
    title: "Lịch giải tội và tĩnh tâm chuẩn bị Mùa Hoa 2026",
    category: "Phụng vụ",
    date: "12/05/2026",
    summary:
      "Thông báo lịch giải tội và giờ tĩnh tâm trong tháng Hoa kính Đức Mẹ.",
    content:
      "Các buổi tĩnh tâm và giải tội sẽ diễn ra vào các tối thứ Sáu hàng tuần tại nhà thờ giáo xứ.",
    image:
      "https://images.unsplash.com/photo-1544928147-79a2dbc1f389?q=80&w=600",
  },

  {
    id: 4,
    slug: "danh-sach-thieu-nhi-xung-toi-lan-dau-2026",
    title: "Danh sách các em thiếu nhi chuẩn bị Xưng Tội Lần Đầu",
    category: "Giáo lý",
    date: "12/05/2026",
    summary:
      "Công bố danh sách các em thiếu nhi tham gia khóa chuẩn bị Xưng Tội Lần Đầu.",
    content:
      "Phụ huynh vui lòng theo dõi danh sách và chuẩn bị đầy đủ hồ sơ cần thiết.",
  },

  {
    id: 5,
    slug: "lich-tap-hat-ca-doan-cecilia-le-chua-thanh-than",
    title: "Lịch tập hát của Ca đoàn Cécilia cho Lễ Chúa Thánh Thần Hiện Xuống",
    category: "Ca đoàn",
    date: "11/05/2026",
    summary: "Thông báo lịch tập hát chuẩn bị cho đại lễ Chúa Thánh Thần.",
    content:
      "Ca đoàn tập trung vào các tối thứ Ba và thứ Năm tại phòng sinh hoạt.",
  },

  {
    id: 6,
    slug: "thong-bao-tu-sua-khuon-vien-dai-duc-me",
    title: "Thông báo về việc tu sửa lại khuôn viên đài Đức Mẹ",
    category: "Xây dựng",
    date: "10/05/2026",
    summary: "Giáo xứ sẽ tiến hành tu sửa và nâng cấp khuôn viên đài Đức Mẹ.",
    content:
      "Công trình dự kiến hoàn thành trong vòng 2 tháng, mong cộng đoàn hiệp thông cầu nguyện.",
  },

  {
    id: 7,
    slug: "ke-hoach-hoi-trai-he-gioi-tre-2026",
    title: "Kế hoạch tổ chức hội trại hè cho giới trẻ năm 2026",
    category: "Giới trẻ",
    date: "09/05/2026",
    summary:
      "Công bố kế hoạch và thời gian tổ chức hội trại hè cho các bạn trẻ.",
    content:
      "Hội trại sẽ diễn ra trong 3 ngày 2 đêm với nhiều hoạt động thiêng liêng và sinh hoạt tập thể.",
  },

  {
    id: 8,
    slug: "mo-lop-giao-ly-hon-nhan-khoa-2-2026",
    title: "Mời gọi tham gia lớp giáo lý hôn nhân khóa II/2026",
    category: "Giáo lý",
    date: "08/05/2026",
    summary:
      "Thông báo mở lớp giáo lý hôn nhân dành cho các bạn chuẩn bị lãnh nhận bí tích.",
    content: "Khóa học gồm 10 buổi học vào tối Chúa Nhật hàng tuần.",
  },
];
